import React from 'react';
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";
import SwapIcon from '@material-ui/icons/SwapHorizSharp';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Submission from '../helpers/Submission';

class ArtifactRow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            SnackBarOpen: false,
            swapped: false
        };
    };

    handleSwap = (event) => {
        if(!this.state.swapped){
            this.props.swapArtifact({
                canvas_assignment_id: this.props.row.canvas_assignment_id,
                canvas_assignment_name: this.props.row.canvas_assignment_name,
                canvas_course_id: this.props.row.canvas_course_id,
                canvas_submission_id: this.props.row.canvas_submission_id,
                outcome_id: this.props.form.outcome.id,
                artifacts: this.props.artifacts,
                canvas_questions: this.props.row.canvas_questions,
                tier:this.props.row.tier,
                lowTierCeiling:this.props.row.lowCeiling,
                highTierFloor:this.props.row.highFloor,
                swapArtifactsSplitNumber:this.props.row.mediumTierSplitNumber
            }).then((obj) => {
                let newRow = obj.payload.artifact;
                if(newRow){
                    newRow.name = this.props.row.name;
                    newRow.course_code = this.props.row.course_code;
                    this.setState({swapped: true, row: newRow});
                } else{
                    this.props.toggleSnackBarCallback();
                }

            })
        } else {
            this.props.swapArtifact({
                canvas_assignment_id: this.state.row.canvas_assignment_id,
                canvas_assignment_name: this.state.row.canvas_assignment_name,
                canvas_course_id: this.state.row.canvas_course_id,
                canvas_submission_id: this.state.row.canvas_submission_id,
                outcome_id: this.props.form.outcome.id,
                artifacts: this.props.artifacts,
                canvas_questions: this.props.row.canvas_questions,
                tier:this.props.row.tier,
                lowTierCeiling:this.props.row.lowCeiling,
                highTierFloor:this.props.row.highFloor,
                swapArtifactsSplitNumber:this.props.row.mediumTierSplitNumber
            }).then((obj) => {
                let newRow = obj.payload.artifact;

                if(newRow){
                    newRow.name = this.props.row.name;
                    newRow.course_code = this.props.row.course_code;
                    this.setState({swapped: true, row: newRow});
                } else{
                    this.props.toggleSnackBarCallback();
                }
            })
        }

    };

    render() {
        if(!this.state.swapped) {
            return (
                <TableRow key={this.props.row.canvas_assignment_id + '-' + this.props.row.canvas_user_id}>
                    <TableCell component="th" scope="row">
                        {this.props.row.course_code}
                    </TableCell>
                    <TableCell>{this.props.row.name}</TableCell>
                    <TableCell>{this.props.row.canvas_assignment_name}</TableCell>
                    <TableCell>{this.props.row.canvas_submission_id}</TableCell>
                    <TableCell><Submission submission={this.props.row}/></TableCell>
                    {this.props.form.checked&&
                    [
                        <TableCell>{this.props.row.tier}</TableCell>,
                        <TableCell>{this.props.row.canvas_score}pts - ({this.props.row.submission_grade_percentage}%)</TableCell>
                    ]
                    }
                    {!this.props.hideActions &&
                    <TableCell><SwapIcon className='hoverPointer' variant="contained" color="secondary" onClick={this.handleSwap}>Swap Artifact</SwapIcon></TableCell>
                    }
                </TableRow>
            );
        } else {
            return (
                <TableRow key={this.state.row.canvas_assignment_id + '-' + this.state.row.canvas_user_id}>
                    <TableCell component="th" scope="row">
                        {this.state.row.course_code}
                    </TableCell>
                    <TableCell>{this.state.row.name}</TableCell>
                    <TableCell>{this.state.row.canvas_assignment_name}</TableCell>
                    <TableCell>{this.state.row.canvas_submission_id}</TableCell>
                    <TableCell><Submission submission={this.state.row}/></TableCell>
                    {this.props.form.checked&&
                    [
                        <TableCell>{this.state.row.tier}</TableCell>,
                        <TableCell>{this.state.row.canvas_score}pts - ({this.state.row.submission_grade_percentage}%)</TableCell>
                    ]
                    }
                    {!this.props.hideActions &&
                    <TableCell><SwapIcon className='hoverPointer' variant="contained" color="secondary" onClick={this.handleSwap}>Swap Artifact</SwapIcon></TableCell>
                    }
                </TableRow>
            );
        }
    }
}

function mapStateToProps(state) {
    return { form: state.newAssessmentForm, artifacts: state.artifacts };
}

export default connect(mapStateToProps, actions)(ArtifactRow);
